import { useCallback } from "react";
import { Input, TextInput } from "../lib";

type Props = {
  disabled?: boolean;
  id: number;
  name: string;
  onChange: (id: number, value: string) => void;
  readOnly?: boolean;
  slug: string;
  value: string | null;
};

export function SocialInput({
  disabled = false,
  readOnly = false,
  id,
  name,
  onChange,
  slug,
  value,
}: Props) {
  // Handlers
  const handleChange = useCallback(
    (_name: string, newValue: string | null) => {
      if (newValue !== null) {
        onChange(id, newValue);
      }
    },
    [id, onChange]
  );

  // Render
  return (
    <Input label={name}>
      <TextInput
        disabled={disabled}
        key={`social-${id}`}
        name={slug}
        onChange={handleChange}
        value={value ?? ""}
        readOnly={readOnly}
        autoCapitalize="none"
        autoCorrect={false}
      />
    </Input>
  );
}
